import { render, staticRenderFns } from "./indicators.vue?vue&type=template&id=53be5158&"
import script from "./indicators.vue?vue&type=script&lang=js&"
export * from "./indicators.vue?vue&type=script&lang=js&"
import style0 from "./indicators.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports